













































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { QuoteProduct } from '@/models/quote-product';
import { OrderHistory } from '@/models/order-history';
import { Order } from '@/models/order';
import { namespace } from 'vuex-class';
import orderStatusLabel from '@/components/order-status-label.vue';
import orderHistoryDescription from '@/components/order-history-description.vue';
import { Permissions } from '@/models/permission-constants';

const UserModule = namespace('user');

@Component({
    components: {
        orderStatusLabel,
        orderHistoryDescription,
    },
})
export default class OrderDetails extends Vue {
    @Prop({ required: true }) public order: Order;
    @Prop({ required: true }) public history: Array<OrderHistory>;
    @UserModule.Getter public canViewOrders: boolean;
    @UserModule.Getter public canCreateOrders: boolean;
    @UserModule.Getter public canViewQuotes: boolean;

    public receiveOrder(): void {
        this.$emit('order-received', this.order.id);
    }
    public deliverOrder(): void {
        this.$emit('order-delivered', this.order.id);
    }
}
